import { t } from '@/lib/i18n';
import { createFileRoute, Link } from '@tanstack/react-router';
import { AuthLayout } from '@/components/auth-layout';
import { VerifyEmailPanel } from '@/features/auth/email-verification/panel';
import { useDocumentTitle } from '@/hooks/use-document-title';

/**
 * Where a verification mail lands: `/verify-email?token=…`.
 *
 * Public and session-free: the link is opened by whatever browser the mailbox is in, which is
 * often not the one that registered. The panel does the single `verify-email` call and offers
 * to send a new mail when the token is stale.
 */
export const Route = createFileRoute('/_auth/verify-email')({
  validateSearch: (search: Record<string, unknown>) => ({
    token:
      typeof search.token === 'string' && search.token !== ''
        ? search.token
        : undefined,
  }),
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  useDocumentTitle(t('邮箱验证'));
  const { token } = Route.useSearch();
  return (
    <AuthLayout
      title={t('邮箱验证')}
      subtitle={t('验证邮箱，确保账号安全与消息送达。')}
    >
      <VerifyEmailPanel token={token} />
      <div className="auth-form__switch">
        <Link to="/login" search={{ redirect: '/' }}>
          {t('返回登录')}
        </Link>
      </div>
    </AuthLayout>
  );
}
